import { render, staticRenderFns } from "./map-dispatch.vue?vue&type=template&id=6232bff2&scoped=true"
import script from "./map-dispatch.vue?vue&type=script&lang=js"
export * from "./map-dispatch.vue?vue&type=script&lang=js"
import style0 from "./map-dispatch.vue?vue&type=style&index=0&id=6232bff2&prod&lang=less"
import style1 from "./map-dispatch.vue?vue&type=style&index=1&id=6232bff2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232bff2",
  null
  
)

export default component.exports